<template>
    <div class="modal-row2 modal-height-max">
        <ul class="nav nav-tabs p-2" id="myTab" role="tablist" v-if="!widthMd(500)">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center" :class="{ active: activeTab === 0 }" @click="activeTab = 0"
                       id="send_data-tab" data-toggle="tab" href="#send_data" role="tab" aria-controls="send_data"
                       aria-disabled="true">Geral</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosOne.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center"
                       :class="{ active: activeTab === 1, 'pointer': true }"
                       @click="checkClick($event, configPosOne.show, 1)"
                       id="position_one-tab"
                       :style="{backgroundColor: activeTab === 1 ? configPosOne.backgroundColor + '!important' : ''}"
                       data-toggle="tab" href="#position_one" role="tab" aria-controls="position_one"
                       aria-disabled="true">
                        <span v-if="configPosOne.show">{{ configPosOne.label }}</span>
                        <s v-else>{{ configPosOne.label }}</s>
                    </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosTwo.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center"
                       :class="{ active: activeTab === 2 }"
                       @click="checkClick($event, configPosTwo.show, 2)"
                       id="position_two-tab"
                       :style="{backgroundColor: activeTab === 2 ? configPosTwo.backgroundColor + '!important' : ''}"
                       data-toggle="tab" href="#position_two" role="tab" aria-controls="position_two"
                       aria-disabled="true">
                        <span v-if="configPosTwo.show">{{ configPosTwo.label }}</span>
                        <s v-else>{{ configPosTwo.label }}</s>
                    </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosThree.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center"
                       :class="{ active: activeTab === 3 }"
                       @click="checkClick($event, configPosThree.show, 3)"
                       id="position_three-tab"
                       :style="{backgroundColor: activeTab === 3 ? configPosThree.backgroundColor + '!important' : ''}"
                       data-toggle="tab" href="#position_three" role="tab"
                       aria-controls="position_three"
                       aria-disabled="true">
                        <span v-if="configPosThree.show">{{ configPosThree.label }}</span>
                        <s v-else>{{ configPosThree.label }}</s>
                    </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosFour.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center"
                       :class="{ active: activeTab === 4 }"
                       @click="checkClick($event, configPosFour.show, 4)"
                       id="position_four-tab" data-toggle="tab" href="#position_four" role="tab"
                       :style="{backgroundColor: activeTab === 4 ? configPosFour.backgroundColor + '!important' : ''}"
                       aria-controls="position_four"
                       aria-disabled="true">
                        <span v-if="configPosFour.show">{{ configPosFour.label }}</span>
                        <s v-else>{{ configPosFour.label }}</s>
                    </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosFive.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link text-center" :class="{ active: activeTab === 5 }"
                       @click="checkClick($event, configPosFive.show, 5)"
                       id="position_five-tab" data-toggle="tab" href="#position_five" role="tab"
                       :style="{backgroundColor: activeTab === 5 ? configPosFive.backgroundColor + '!important' : ''}"
                       aria-controls="position_five"
                       aria-disabled="true">
                        <span v-if="configPosFive.show">{{ configPosFive.label }}</span>
                        <s v-else>{{ configPosFive.label }}</s>
                    </a>
                </li>
            </div>
        </ul>

        <div v-if="loading" class="text-center p-4">
            <div class="spinner-border" role="status">
                <span class="visually-hidden"></span>
            </div>
        </div>

        <form @submit.prevent v-else>
            <div class="tab-content modal-body" style="padding-top: 0" id="myTabContent">
                <div class="tab-pane fade" :class="{ active: activeTab === 0, show: activeTab === 0 }"
                     id="send_data"
                     role="tabpanel" aria-labelledby="send_data-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="nameConf">Nome: </label>
                                <input type="text"
                                       id="nameConf"
                                       v-model="form.name"
                                       name="nameConf"
                                       class="form-control">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label>Configuração de Simulador:</label>
                                <div class="form-control bg-light d-flex align-items-center">
                                    {{ simulatorConfig?.name }}
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="generateContactPhone">Nº Telefone:</label>
                                <input id="generateContactPhone" type="text" class="form-control"
                                       placeholder="Ex.: 55 11 999999999"
                                       v-model.trim="form.phone_number_to_send">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="generateContactEmail">E-mail:</label>
                                <input id="generateContactEmail" type="text" class="form-control"
                                       placeholder="Ex.: email@dominio.com"
                                       v-model.trim="form.email_to_send">
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="descriptionConf">Descrição: </label>
                                <textarea type="text"
                                          id="descriptionConf"
                                          v-model="form.description"
                                          name="descriptionConf"
                                          class="form-control">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <!--                Posição 1-->
                <div class="tab-pane fade" :class="{ active: activeTab === 1, show: activeTab === 1 }"
                     id="position_one"
                     role="tabpanel" aria-labelledby="position_one-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Valor mínimo de {{ configPosOne.label }}: <b>{{
                                    simulatorConfig?.entrance_fixed
                                        ? formatToBRL(simulatorConfig?.entrance_value ?? 0)
                                        : `${(simulatorConfig?.entrance_value ?? 0).toFixed(4)}%`
                                }}</b></div>
                            <div>Periodicidade: <b>{{ configPosOne.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosOne.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosOne.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosOne.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosOne.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosOne.maxQuantityInstallment }} </b></div>
                            <div>Juros: <b>{{ configPosOne.interest.toFixed(4) }}%</b></div>
                        </div>

                    </div>
                </div>

                <!--                Posição 2-->
                <div class="tab-pane fade" :class="{ active: activeTab === 2, show: activeTab === 2 }"
                     id="position_two"
                     role="tabpanel" aria-labelledby="position_two-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Valor de {{ configPosTwo.label }}: <b>{{
                                    simulatorConfig?.arras_value
                                        ? formatToBRL(simulatorConfig?.arras_value ?? 0)
                                        : `${(simulatorConfig?.arras_value ?? 0).toFixed(4)}%`
                                }}</b></div>
                            <div>Periodicidade: <b>{{ configPosTwo.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosTwo.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosTwo.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosTwo.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosTwo.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosTwo.maxQuantityInstallment }} </b></div>
                            <div>Juros: <b>{{ configPosTwo.interest.toFixed(4) }}%</b></div>
                        </div>

                    </div>
                </div>

                <!--                Posição 3-->
                <div class="tab-pane fade" :class="{ active: activeTab === 3, show: activeTab === 3 }"
                     id="position_three"
                     role="tabpanel" aria-labelledby="position_three-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Periodicidade: <b>{{ configPosThree.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosThree.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosThree.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosThree.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosThree.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosThree.maxQuantityInstallment }} </b>
                            </div>
                            <div>Juros: <b>{{ configPosThree.interest.toFixed(4) }}%</b></div>
                        </div>

                    </div>
                </div>

                <!--                Posição 4-->
                <div class="tab-pane fade" :class="{ active: activeTab === 4, show: activeTab === 4 }"
                     id="position_four"
                     role="tabpanel" aria-labelledby="position_four-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Valor mínimo de {{ configPosFour.label }}: <b>{{
                                    simulatorConfig?.brokerage_value
                                        ? formatToBRL(simulatorConfig?.brokerage_value ?? 0)
                                        : `${(simulatorConfig?.brokerage_value ?? 0).toFixed(4)}%`
                                }}</b></div>
                            <div>Periodicidade: <b>{{ configPosFour.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosFour.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosFour.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosFour.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosFour.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosFour.maxQuantityInstallment }} </b>
                            </div>
                            <div>Juros: <b>{{ configPosFour.interest.toFixed(4) }}%</b></div>
                        </div>

                    </div>
                </div>

                <!--                Posição 5-->
                <div class="tab-pane fade" :class="{ active: activeTab === 5, show: activeTab === 5 }"
                     id="position_five"
                     role="tabpanel" aria-labelledby="position_five-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Periodicidade: <b>{{ configPosFive.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosFive.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosFive.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosFive.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosFive.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosFive.maxQuantityInstallment }} </b>
                            </div>
                            <div>Juros: <b>{{ configPosFive.interest.toFixed(4) }}%</b></div>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="parcelsQuantityTypeFive">Quantidade de Parcelas: </label>
                                <input type="text" id="parcelsQuantityTypeFive"
                                       v-model="form.parcelsQuantityTypeFive" name="parcelsQuantityTypeFive"
                                       class="form-control" placeholder="20,60">
                                <div class="d-flex d-inline-block">
                                    <small class="text-muted" v-if="configPosFive.minQuantityInstallment">
                                        Mín.: {{ configPosFive.minQuantityInstallment }}
                                    </small>
                                    <small class="text-muted" v-if="configPosFive.maxQuantityInstallment">
                                        {{
                                            `${configPosFive.minQuantityInstallment ? ', ' : ''}Máx.: ${configPosFive.maxQuantityInstallment}`
                                        }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="modal-footer justify-content-end">
                <div>
                    <button class="btn btn-secondary mr-2" type="button" id="closeAddConf"
                            data-dismiss="modal" @click="cancel">Fechar
                    </button>
                    <button type="button"
                            class="btn btn-primary"
                            @click="generatePriceTable">
                        Gerar Tabela de Preços
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import stores from '@/vuex';
import {useI18n} from 'vue-i18n';
import {Money3Directive} from 'v-money3';
import Translate from '@/Helpers/Translate';
import {useToast} from 'vue-toastification';
import PriceTable from '@/services/PriceTable';
import paymentMethods from '@/services/paymentMethods';

export default {
    name: 'createPriceTableConfigComponent',

    emits: ['save'],

    directives: {
        money3: Money3Directive,
    },

    setup() {
        const toast = useToast();
        const { t } = useI18n();
        return { t, toast };
    },

    props: {
        priceTableIdOpen: {
            type: Number,
            default: null,
        },
        allotmentId: {
            type: [Number, String],
            default: null,
        },
    },

    data() {
        return {
            loading: true,
            activeTab: 0,
            simulatorConfig: null,
            inputPosOne: {},
            inputPosTwo: {},
            inputPosThree: {},
            inputPosFour: {},
            inputPosFive: {},
            periodicityOptions: { 1: 'Mensal', 3: 'Trimestral', 6: 'Semestral', 12: 'Anual' },
            paymentForms: {},
            form: {},
            configOptions: [],
            priceTableIdCurrent: null,

            configCurrencyValue: {
                suffix: '',
                decimal: ',',
                number: true,
                masked: true,
                thousands: '.',
                prefix: 'R$ ',
                disabled: false,
                max: 100000000000,
                minimumNumberOfCharacters: 1,
            },
            configManualEntrance: {
                max: 100,
                prefix: '',
                decimal: '.',
                number: true,
                thousands: '',
                masked: true,
                suffix: '%',
                disabled: false,
                minimumNumberOfCharacters: 0,
            },

            formValues: {
                entrance: 0,
                arras: 0,
                brokerage: 0,
                regularInstallments: 0,
                intermediateInstallments: 0,
                formula: 'PRICE',
            },
            availableFormulas: ['PRICE', 'SAC'],
        };
    },

    computed: {
        configPosOne() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 1);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 1],
                show: config?.show ?? true,
                paymentForm: this.paymentForms[config?.default_payment_form_id],
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: Number(config?.interest ?? 0),
            };
        },

        configPosTwo() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 2);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 2],
                show: config?.show ?? true,
                paymentForm: this.paymentForms[config?.default_payment_form_id],
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: Number(config?.interest ?? 0),
            };
        },

        configPosThree() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 3);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 3],
                show: config?.show ?? true,
                paymentForm: this.paymentForms[config?.default_payment_form_id],
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: Number(config?.interest ?? 0),
            };
        },

        configPosFour() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 4);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 4],
                show: config?.show ?? true,
                paymentForm: this.paymentForms[config?.default_payment_form_id],
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: Number(config?.interest ?? 0),
            };
        },

        configPosFive() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 5);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 5],
                show: config?.show ?? true,
                paymentForm: this.paymentForms[config?.default_payment_form_id],
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: Number(config?.interest ?? 0),
            };
        },

        configPercentageValue() {
            return {
                max: 100,
                prefix: '',
                decimal: '.',
                number: true,
                thousands: '',
                masked: false,
                suffix: '%',
                precision: 4,
                disabled: false,
                minimumNumberOfCharacters: 0,
            };
        },

    },

    methods: {
        setConfigTablePrice(config, configOptions, selectedSimulatorConfigId = null, context = {}) {
            this.loading = true;
            this.activeTab = 0;
            this.simulatorConfig = config;
            this.configOptions = configOptions;
            this.priceTableIdCurrent = context?.priceTableId ?? this.priceTableIdOpen ?? null;
            const selectedId = selectedSimulatorConfigId ?? configOptions?.[0]?.id;
            this.form = {
                ...this.form,
                simulatorConfig: selectedId ? String(selectedId) : null,
                name: context?.defaultName ?? this.form?.name ?? '',
                description: context?.defaultDescription ?? this.form?.description ?? '',
                phone_number_to_send: this.form?.phone_number_to_send ?? null,
                email_to_send: this.form?.email_to_send ?? null,
                entranceValueSource: this.form?.entranceValueSource ?? 'simulator',
                deductEntranceFromLot: this.form?.deductEntranceFromLot ?? false,
            };
            this.setConfigManualEntrance(this.form.entranceManualIsPercentage ?? true);
            this.setSuggestedTypeFiveInstallments();

            this.inputPosOne.value = this.simulatorConfig.entrance_value;
            this.inputPosOne.periodicity = this.configPosOne.periodicity;

            setTimeout(() => {
                this.loading = false;
            }, 500);

            this.getPaymentMethods();
        },

        checkClick(event, show, position) {
            if (!show) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }

            this.activeTab = position;
        },

        getPaymentMethods() {
            paymentMethods.list()
                .then(resp => {
                    this.paymentForms = resp.data.reduce((acc, item) => {
                        acc[item.id] = item.text;
                        return acc;
                    }, {});
                })
                .catch(err => this.errorMsg(err));
        },

        formatToBRL(value) {
            return Translate.formatToBRL(value);
        },

        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },

        handleBody() {
            const messages = [];
            const body = {};
            const resolvedAllotmentId = this.getResolvedAllotmentId();

            if (!this.form.entranceValueSource) this.form.entranceValueSource = 'simulator';

            if (this.form.entranceValueSource === 'manual' && !this.form.entranceValueManual) {
                messages.push('Obrigatório informar o valor da entrada manual.');
            }
            if (this.form.entranceValueSource === 'manual') {
                const manualValue = this.parseManualEntranceValue();
                if (manualValue === null || Number.isNaN(manualValue)) {
                    messages.push('Valor da entrada manual inválido.');
                } else if (this.form.entranceManualIsPercentage && (manualValue < 0 || manualValue > 100)) {
                    messages.push('Para entrada em porcentagem, informe um valor entre 0 e 100.');
                } else if (!this.form.entranceManualIsPercentage && manualValue <= 0) {
                    messages.push('Para entrada em valor fixo, informe um valor maior que zero.');
                }
            }

            //tratamento tipo 5
            if (!this.form.parcelsQuantityTypeFive) {
                messages.push(`Obrigatório preencher a quantidade de parcelas do tipo ${this.configPosFive.label}`);
            } else {
                const parcelsTypeFive = this.normalizeParcelsInput(this.form.parcelsQuantityTypeFive);
                const minQuantity = this.getEffectiveMinQuantity(this.configPosFive);
                const maxQuantity = this.getEffectiveMaxQuantity(this.configPosFive);
                const invalidInstallments = parcelsTypeFive.filter(quantity => quantity < minQuantity || quantity > maxQuantity);

                if (parcelsTypeFive.length === 0) {
                    messages.push(`Quantidade de parcelas mal formatada para parcelas do tipo ${this.configPosFive.label}`);
                } else if (invalidInstallments.length > 0) {
                    messages.push(`As parcelas de ${this.configPosFive.label} devem ficar entre ${minQuantity} e ${maxQuantity}. Valores inválidos: ${invalidInstallments.join(', ')}`);
                } else body.parcelsQuantityTypeFive = parcelsTypeFive;
            }

            if (messages.length > 0) {
                messages.forEach(message => this.toast.info(message, { timeout: 0 }));

                return false;
            }

            if (!this.form.phone_number_to_send && !this.form.email_to_send) {
                this.toast.info('Informe um número de telefone ou e-mail para continuar.');
                return false;
            }

            if (!resolvedAllotmentId) {
                this.toast.info('Loteamento não identificado para gerar a tabela.');
                return false;
            }

            return body;
        },

        normalizeParcelsInput(inputQuantity) {
            const values = String(inputQuantity ?? '')
                .split(',')
                .map(item => Number(String(item).trim()))
                .filter(item => Number.isInteger(item) && item > 0);

            return [...new Set(values)].sort((a, b) => a - b);
        },

        getEffectiveMinQuantity(positionConfig) {
            const min = Number(positionConfig?.minQuantityInstallment);
            return Number.isInteger(min) && min > 0 ? min : 1;
        },

        getEffectiveMaxQuantity(positionConfig) {
            const min = this.getEffectiveMinQuantity(positionConfig);
            const max = Number(positionConfig?.maxQuantityInstallment);

            if (!Number.isInteger(max) || max <= 0) {
                return Math.max(min, 180);
            }

            return Math.max(min, max);
        },

        getResolvedAllotmentId() {
            const fromProp = this.allotmentId != null ? String(this.allotmentId).trim() : '';
            if (fromProp && fromProp !== 'null' && fromProp !== 'undefined') return fromProp;

            const fromSession = (sessionStorage.getItem('allotmentIdScope') || '').trim();
            if (fromSession && fromSession !== 'null' && fromSession !== 'undefined') return fromSession;

            const fromLocal = (localStorage.getItem('allotmentId') || '').trim();
            if (fromLocal && fromLocal !== 'null' && fromLocal !== 'undefined') return fromLocal;

            return null;
        },

        getSuggestedTypeFiveInstallments() {
            const minInstallments = this.getEffectiveMinQuantity(this.configPosFive);
            const maxInstallments = this.getEffectiveMaxQuantity(this.configPosFive);
            if (maxInstallments <= 0 || minInstallments > maxInstallments) return '';

            const suggested = [minInstallments];
            for (let value = 12; value <= maxInstallments; value += 12) {
                if (value < minInstallments) continue;
                suggested.push(value);
            }

            if (suggested[suggested.length - 1] !== maxInstallments) {
                suggested.push(maxInstallments);
            }

            return [...new Set(suggested)].sort((a, b) => a - b).join(',');
        },

        setSuggestedTypeFiveInstallments() {
            this.form.parcelsQuantityTypeFive = this.getSuggestedTypeFiveInstallments();
        },

        setConfigManualEntrance(type) {
            this.form.entranceManualIsPercentage = type;
            if (type) {
                this.configManualEntrance.max = 100;
                this.configManualEntrance.prefix = '';
                this.configManualEntrance.decimal = '.';
                this.configManualEntrance.thousands = '';
                this.configManualEntrance.suffix = '%';
                this.configManualEntrance.minimumNumberOfCharacters = 0;
            } else {
                this.configManualEntrance.suffix = '';
                this.configManualEntrance.decimal = ',';
                this.configManualEntrance.thousands = '.';
                this.configManualEntrance.prefix = 'R$ ';
                this.configManualEntrance.max = 100000000000;
                this.configManualEntrance.minimumNumberOfCharacters = 1;
            }
        },

        parseManualEntranceValue() {
            if (!this.form.entranceValueManual && this.form.entranceValueManual !== 0) return null;

            let value = String(this.form.entranceValueManual);
            if (this.form.entranceManualIsPercentage) {
                value = value.replaceAll('%', '').replaceAll(',', '.');
            } else {
                value = value.replaceAll('R$ ', '').replaceAll('.', '').replaceAll(',', '.');
            }

            return Number(value);
        },

        cancel() {
            document.getElementById('closeX')?.click();
            this.loading = false;
            this.form = {};
            this.activeTab = 0;
            this.simulatorConfig = null;
            this.priceTableIdCurrent = null;
            this.inputPosOne = {};
            this.inputPosTwo = {};
            this.inputPosThree = {};
            this.inputPosFour = {};
            this.inputPosFive = {};
            this.paymentForms = {};
            this.form = {};
            this.configOptions = [];
            this.configCurrencyValue = {
                suffix: '',
                decimal: ',',
                number: true,
                masked: true,
                thousands: '.',
                prefix: 'R$ ',
                disabled: false,
                max: 100000000000,
                minimumNumberOfCharacters: 1,
            };
        },

        async generatePriceTable() {
            const validation = this.handleBody();
            if (validation) {
                const normalizedInstallments = this.normalizeParcelsInput(this.form.parcelsQuantityTypeFive);
                const quantityInstallment = normalizedInstallments.join(',');
                this.form.parcelsQuantityTypeFive = quantityInstallment;
                const resolvedAllotmentId = this.getResolvedAllotmentId();
                const simulatorConfigId = Number(this.form.simulatorConfig);
                if (!simulatorConfigId) {
                    this.toast.info('Configuração de simulador inválida.');
                    return;
                }

                const body = {
                    simulator_config_id: simulatorConfigId,
                    allotment_id: resolvedAllotmentId,
                    quantity_installment: quantityInstallment,
                    email_to_send: this.form.email_to_send ?? null,
                    phone_number_to_send: this.form.phone_number_to_send ?? null,
                };
                if (validation?.rules) {
                    body.rules = validation.rules;
                }

                try {
                    stores.commit('changeLoading', true);
                    const resp = await PriceTable.generate(body);
                    this.$emit('save', resp?.data ?? null);
                    document.getElementById('closeAddConf')?.click();
                } catch (e) {
                    if (e?.response?.status === 422) {
                        const backendMessage = e?.response?.data?.message
                            || e?.response?.data?.error
                            || 'Não foi possível gerar a tabela de preços.';
                        this.toast.info(backendMessage);
                        return;
                    }
                    this.errorMsg(e);
                } finally {
                    stores.commit('changeLoading', false);
                }
            }
        },
    },
};

</script>

<style scoped>
.modal-height-max {
    max-height: 90vh;
    overflow-y: auto;
}

.config-details {
    margin-top: 1.5rem;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    background-color: #f8f9fa;
}

.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    display: block;
}

.input-group-text {
    min-width: 40px;
    justify-content: center;
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn i {
    margin-right: 0.5rem;
}

.text-muted {
    font-size: 0.75rem;
    display: block;
    margin-top: 0.25rem;
}

.card {
    border: none;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 1rem 1.25rem;
}

.card-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
}

.card-body {
    padding: 1.5rem;
}
</style>
